export const ITEMS_PER_PAGE = 75;
export const EXPORT_SIZE = 20000; // The node backend can reliably export up to 20k rows
